<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-21 11:28:49
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-30 22:01:44
 * @FilePath: /notion-widgets-site/src/components/home/FirstPanel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main-container">
    <el-carousel indicator-position="outside" class="swiper">
      <el-carousel-item>
        <div class="panel" id="panel-01">
          <div class="left-panel">
            <h1>个性化自定义你的组件</h1>
            <p>只要动动手就可以拥有专属于自己的个人组件</p>
            <p>无个数限制，支持嵌入Notion，Wolai，FlowUs等笔记软件</p>
            <el-button
              type="primary"
              size="medium"
              round
              id="main-btn"
              @click="handleStart"
              >开始使用</el-button
            >
          </div>
          <div class="right-panel">
            <img class="main-img" src="@/assets/home.png" alt="" />
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="panel" id="panel-02">
          <div class="left-panel">
            <img class="main-img_win" src="@/assets/home-page_1.png" alt="" />
          </div>
          <div class="right-panel text-panel">
            <h2>打造个性化个人页面</h2>
            <p>丰富页面，把笔记做成网站</p>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="panel" id="panel-03">
          <div class="left-panel text-panel">
            <h2>更加直观的数据感受</h2>
            <p>也可作为模块分割的工具</p>
          </div>
          <div class="right-panel">
            <img class="main-img_win" src="@/assets/home-page_2.png" alt="" />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="panel" id="panel-04">
      <div class="left-panel">
        <img class="main-img_win2" src="@/assets/home-page_3.png" alt="" />
      </div>
      <div class="right-panel">
        <img class="main-img_win2" src="@/assets/home-page_4.png" alt="" />
      </div>
    </div>
    <div class="panel" id="like-list">
      <h2>🔥 最受欢迎 🔥</h2>
      <div class="list">
        <div class="list-item" v-for="(item, index) in list" :key="item.id">
          <div class="img-box">
            <img :src="item.cover" alt="" />
          </div>
          <h4>
            NO.{{ index + 1 }} {{ item.tag }}
            <router-link class="view" :to="`/create/${item.id}/${item.type}`"
              >>> 查看</router-link
            >
          </h4>
        </div>
      </div>
    </div>
    <div class="panel" id="guide">
      <div class="text-panel">
        <h2>开始配置你的组件吧</h2>
        <p>Get started for free.</p>
        <el-button
          type="primary"
          size="medium"
          round
          id="main-btn"
          @click="handleStart"
          >开始使用</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Lib from "../../lib";
export default {
  data() {
    return {
      list: [
        {
          id: 29,
          cover: "./assets/widget-29.png",
          tag: "范围日历",
          link: "https://httishere.github.io/notion-widget/calendarByWeek.html",
          mode: "light",
          timestamp: "1673107200000",
          type: "time",
        },
        {
          id: 7,
          cover: "./assets/20220104111624.png",
          tag: "年度格子",
          link: "https://httishere.github.io/notion-widget/new/year-block.html",
          mode: "light",
          dark: false,
          type: "time",
        },
        {
          id: 31,
          cover: "./assets/wids/widget-31.png",
          tag: "区间进度条",
          link: "https://httishere.github.io/notion-widget/v201/custom-progress.html",
          mode: "all",
          timestamp: "1674748800000",
          type: "time",
        },
        {
          id: 1,
          cover: "./assets/20211230144940.png",
          tag: "进度时钟",
          link: "https://httishere.github.io/notion-widget/progress.html",
          mode: "light",
          type: "time",
        },
        {
          id: 12,
          cover: "./assets/Xnip2022-01-06_12-37-34.jpg",
          tag: "日历卡片",
          link: "https://httishere.github.io/notion-widget/new/calendar.html",
          mode: "all",
          dark: false,
          monday: true,
          type: "time",
        },
        {
          id: 1001.2,
          cover: "./assets/refer-1.2.png",
          tag: "细文字引用块",
          link: "https://httishere.github.io/notion-widget/quote3.html",
          desc: "『注』：适合繁体，日文和英文文案，中等字体，该字体无法识别部分简体字，引用了特殊字体预览效果可能会有延迟。",
          font_color: "#333333",
          size: "auto",
          timestamp: "1640793600000",
          type: "others",
        },
      ],
    };
  },
  methods: {
    handleStart() {
      this.$router.push("/lib");
    },
  },
  mounted() {
    // if (Lib.isPhone()) {
    //   console.log(".....");
    //   this.$router.replace({ name: "mbase" });
    // }
  },
};
</script>
<style lang="less" scoped>
@import "../../less/var.less";
.main-container {
  // padding: 70px;
  padding-bottom: 20px;
  position: relative;
  z-index: 1;
}
.swiper {
  // height: 65vh;
  padding-bottom: 20px;
  margin-top: 80px;
}
.el-carousel__item,
.el-carousel__container {
  height: 65vh;
}
.panel {
  width: 88vw;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  // padding-top: 80px;
  align-items: center;
  p {
    font-size: 24px;
  }
  .text-panel {
    width: 38vw;
    text-align: center;
    h2 {
      font-size: 30px;
    }
  }
}
#main-btn {
  width: 160px;
  height: 50px;
  border-radius: 50px;
  font-size: 24px;
}
.main-img {
  width: 40vw;
}
.main-img_win {
  width: 60vw;
  //   box-shadow: 0px 36px 89px rgba(0, 0, 0, 0.04), 0px 23.3333px 52.1227px rgba(0, 0, 0, 0.0303704), 0px 13.8667px 28.3481px rgba(0, 0, 0, 0.0242963), 0px 7.2px 14.4625px rgba(0, 0, 0, 0.02), 0px 2.93333px 7.25185px rgba(0, 0, 0, 0.0157037), 0px 0.666667px 3.50231px rgba(0, 0, 0, 0.00962963);
}
.main-img_win2 {
  width: 45vw;
}
#panel-01 {
  // margin-top: 90px;
  h1 {
    font-size: 60px;
    font-weight: 700;
  }
}
#like-list {
  display: block;
  padding-bottom: 20px;
  text-align: center;
  h2 {
    font-size: 30px;
  }
  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-item {
      width: 25vw;
      cursor: pointer;
      padding: 1vw;
      .img-box {
        width: 100%;
        height: 20vw;
        line-height: 20vw;
        img {
          width: 100%;
          max-height: 20vw;
        }
      }
      h4 {
        font-size: 18px;
        position: relative;
        .view {
          color: #999999;
          font-size: 12px;
          display: none;
          position: absolute;
          right: 0;
        }
      }
      &:hover {
        transform: translateY(-10px);
        transition: all 0.2s ease-in-out;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
        .view {
          display: inline-block;
          color: @focus-color;
        }
      }
    }
  }
}
#guide,
#like-list {
  justify-content: center;
}
</style>
